import React, { useEffect } from 'react';
import HeadingOne from '../../components/HeadingOne';

const TermsAndConditionsPage = () => {
    useEffect(() => {
        document.title = `Algemene voorwaarden - Private Gym Schijndel`;
    }, []);

    return (
        <>
            <section className="hero rooms-hero">
                <div className="default-container flex justify-center items-center h-full w-full">
                    <div className="text-center">
                        <HeadingOne>
                            Algemene voorwaarden.
                        </HeadingOne>
                        <h3 className="text-primary-500 pt-2 pb-16">De algemene voorwaarden van Private Gym
                            Schijndel.</h3>
                    </div>
                </div>
            </section>

            <section className="medium-container">
                <p className="p1 pt-6 pb-2 pt-4"><strong>ALGEMENE VOORWAARDEN NS PERFORMANCE &ndash; PRIVATE
                    GYM</strong></p>
                <p className="p1 pt-6 pb-2 pt-4"><strong>SCHIJNDEL</strong></p>
                <p className="p2 py-1 pt-4"><strong>Artikel 1 &ndash; Toepasselijkheid</strong></p>
                <p className="p2 py-1">Deze algemene voorwaarden zijn van toepassing op iedere overeenkomst tussen het
                    bedrijf</p>
                <p className="p2 py-1 pt-4"><strong>NS PERFORMANCE</strong>, handelend onder de naa pt-4m <strong>Private
                    Gym
                    Schijndel</strong>, en een deelnemer</p>
                <p className="p2 py-1">die zich &ndash; direct of indirect &ndash; inschrijft voor personal training,
                    voedingsbegeleiding,</p>
                <p className="p2 py-1">groepslessen of andere diensten van NS PERFORMANCE. Afwijkingen van deze</p>
                <p className="p2 py-1">voorwaarden zijn slechts bindend indien deze schriftelijk zijn
                    overeengekomen.</p>
                <p className="p2 py-1 pt-4"><strong>Artikel 2 &ndash; Inschrijving en toelating</strong></p>
                <p className="p2 py-1">1. 2. 3. Voor deelname is een volledig en naar waarheid ingevuld intakeformulier
                    verplicht.</p>
                <p className="p2 py-1">NS PERFORMANCE behoudt zich het recht voor om zonder opgaaf van reden een</p>
                <p className="p2 py-1">aanmelding te weigeren, bijvoorbeeld bij contra-indicaties voor fysieke
                    inspanning.</p>
                <p className="p2 py-1">De deelnemer is zelf verantwoordelijk voor het tijdig melden van medische of
                    fysieke</p>
                <p className="p2 py-1">beperkingen.</p>
                <p className="p2 py-1 pt-4"><strong>Artikel 3 &ndash; Betaling en incasso</strong></p>
                <p className="p2 py-1">1. 2. 3. Betaling geschiedt vooraf per automatische incasso, contant of via
                    bankoverschrijving,</p>
                <p className="p2 py-1">binnen 14 dagen na factuurdatum.</p>
                <p className="p2 py-1">Bij het uitblijven van tijdige betaling is NS PERFORMANCE gerechtigd verdere</p>
                <p className="p2 py-1">dienstverlening op te schorten of de overeenkomst per direct te
                    be&euml;indigen.</p>
                <p className="p2 py-1">Eventuele kosten voor incasso, administratie of gerechtelijke stappen zijn
                    volledig</p>
                <p className="p2 py-1">voor rekening van de deelnemer.</p>
                <p className="p2 py-1 pt-4"><strong>Artikel 4 &ndash; Begeleiding en uitvoering</strong></p>
                <p className="p2 py-1">1. 2. 3. NS PERFORMANCE spant zich in om trainingen professioneel en doelgericht
                    uit
                    te</p>
                <p className="p2 py-1">voeren met daartoe gekwalificeerd personeel.</p>
                <p className="p2 py-1">NS PERFORMANCE behoudt zich het recht voor om een andere trainer toe te
                    wijzen</p>
                <p className="p2 py-1">dan oorspronkelijk overeengekomen.</p>
                <p className="p2 py-1">NS PERFORMANCE geeft geen garantie op specifieke resultaten, aangezien deze</p>
                <p className="p2 py-1">mede afhankelijk zijn van de inzet van de deelnemer.</p>
                <p className="p2 py-1 pt-4"><strong>Artikel 5 &ndash; Aansprakelijkheid en eigen risico</strong></p>
                <p className="p2 py-1">1. 2. 3. 4. Deelname aan trainingen en het gebruik van faciliteiten bij Private
                    Gym
                    Schijndel</p>
                <p className="p2 py-1">geschiedt geheel op eigen risico.</p>
                <p className="p2 py-1">NS PERFORMANCE is niet aansprakelijk voor blessures, lichamelijke klachten,</p>
                <p className="p2 py-1">materi&euml;le schade of verlies van persoonlijke eigendommen, tenzij er sprake
                    is
                    van</p>
                <p className="p2 py-1">opzet of grove nalatigheid.</p>
                <p className="p2 py-1">De deelnemer vrijwaart NS PERFORMANCE voor aanspraken van derden die</p>
                <p className="p2 py-1">voortvloeien uit zijn/haar deelname.</p>
                <p className="p2 py-1">Schade als gevolg van onjuiste of onvolledige informatie in het intakeformulier
                    of
                    het</p>
                <p className="p2 py-1">negeren van aanwijzingen komt voor rekening van de deelnemer.</p>
                <p className="p2 py-1 pt-4"><strong>Artikel 6 &ndash; Annulering, afmelding en verzuim</strong>1. 2. 3.
                    4.
                    Afspraken dienen minimaal 24 uur van tevoren te worden geannuleerd.</p>
                <p className="p2 py-1">Bij niet-tijdige annulering, te late komst of afwezigheid zonder geldige reden,
                    vervalt</p>
                <p className="p2 py-1">het recht op inhalen van de sessie en worden de kosten volledig in rekening
                    gebracht.</p>
                <p className="p2 py-1">Gemiste sessies kunnen uitsluitend in overleg binnen vier weken worden
                    ingehaald,</p>
                <p className="p2 py-1">mits aan de annuleringsvoorwaarden is voldaan.</p>
                <p className="p2 py-1">Bij langdurige afwezigheid wegens medische redenen dient een schriftelijk bewijs
                    te</p>
                <p className="p2 py-1">worden overlegd. Op basis daarvan kan in overleg worden besloten tot
                    tijdelijke</p>
                <p className="p2 py-1">opschorting van de overeenkomst.</p>
                <p className="p2 py-1 pt-4"><strong>Artikel 7 &ndash; Gedragscode en huisregels</strong></p>
                <p className="p2 py-1">1. 2. 3. 4. De deelnemer dient zich te allen tijde respectvol te gedragen
                    tegenover de
                    trainers,</p>
                <p className="p2 py-1">andere deelnemers en de faciliteiten van Private Gym Schijndel.</p>
                <p className="p2 py-1">Alleen ingeschreven deelnemers hebben toegang tot de trainingen. Het meenemen
                    van</p>
                <p className="p2 py-1">derden is uitsluitend toegestaan na voorafgaande toestemming.</p>
                <p className="p2 py-1">De deelnemer dient instructies van de trainer strikt op te volgen.</p>
                <p className="p2 py-1">Het dragen van schone sportkleding en gepast schoeisel is verplicht. NS</p>
                <p className="p2 py-1">PERFORMANCE behoudt zich het recht voor om deelnemers de toegang te weigeren</p>
                <p className="p2 py-1">bij ongepast gedrag of onvoldoende hygi&euml;ne.</p>
                <p className="p2 py-1 pt-4"><strong>Artikel 8 &ndash; Overmacht</strong></p>
                <p className="p2 py-1">In geval van overmacht &ndash; waaronder ziekte van de trainer, technische
                    storingen,</p>
                <p className="p2 py-1">overheidsmaatregelen of andere onvoorziene omstandigheden &ndash; behoudt NS</p>
                <p className="p2 py-1">PERFORMANCE zich het recht voor om trainingen te verplaatsen of te annuleren.
                    In</p>
                <p className="p2 py-1">dergelijke gevallen kan geen aanspraak worden gemaakt op schadevergoeding.</p>
                <p className="p2 py-1 pt-4"><strong>Artikel 9 &ndash; Geschillen en toepasselijk recht</strong></p>
                <p className="p2 py-1">1. 2. Op alle overeenkomsten met NS PERFORMANCE / Private Gym Schijndel is</p>
                <p className="p2 py-1">uitsluitend Nederlands recht van toepassing.</p>
                <p className="p2 py-1">Geschillen worden voorgelegd aan de bevoegde rechter in het arrondissement
                    waarin</p>
                <p className="p2 py-1">NS PERFORMANCE is gevestigd, tenzij dwingend recht anders voorschrijft.</p>
            </section>
        </>
    )
}

export default TermsAndConditionsPage;
